import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const AddBreakMedia = ({})=> {

  const currentUser = security.currentUserValue;
  const apiKey      = 'bd02756130a554f019fa32d11655e5da1b37a2d15184b1c202f74c8b20a193a4';

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        style={{width:"100%", height:"92vh", border:0, padding:0, margin:0}}
        scrolling="yes"
        frameBorder="0"
        allow="autoplay;encrypted-media"
        src={`https://wall.adbreakmedia.com/${apiKey}/${currentUser.id}`}
      ></iframe>
    </Fragment>
  );
};

export default AddBreakMedia;
